export default "__VITE_ASSET__9UyXTx5C__"